/**
 * Motion / accelerometer probes via DeviceMotion (competitor-style short listen).
 * Desktop often times out with false; phones typically emit accelerationIncludingGravity quickly.
 */

const DEVICE_MOTION_PROBE_MS = 60;

/**
 * True if a devicemotion event reports non-null accelerationIncludingGravity axes (0 is valid).
 * @returns {Promise<boolean>}
 */
function probeAccelerometerFromDeviceMotion() {
    return new Promise((resolve) => {
        let settled = false;
        function finish(value) {
            if (settled) {
                return;
            }
            settled = true;
            clearTimeout(tid);
            window.removeEventListener('devicemotion', onMotion);
            resolve(value);
        }
        const tid = setTimeout(() => finish(false), DEVICE_MOTION_PROBE_MS);
        function onMotion(e) {
            const a = e.accelerationIncludingGravity;
            if (
                a != null &&
                a.x != null &&
                a.y != null &&
                a.z != null
            ) {
                finish(true);
            }
        }
        window.addEventListener('devicemotion', onMotion, { passive: true });
    });
}

/**
 * @returns {Promise<{ deviceMotionEventSupported: boolean, accelerometerFromMotion: boolean }>}
 */
export async function collectSensors() {
    const deviceMotionEventSupported = typeof window.DeviceMotionEvent !== 'undefined';
    if (!deviceMotionEventSupported) {
        return {
            deviceMotionEventSupported: false,
            accelerometerFromMotion: false,
        };
    }

    let accelerometerFromMotion = false;
    try {
        accelerometerFromMotion = await probeAccelerometerFromDeviceMotion();
    } catch {
        accelerometerFromMotion = false;
    }
    return {
        deviceMotionEventSupported,
        accelerometerFromMotion,
    };
}
